<template>
    <b-tooltip :position="position" :auto-close="['outside', 'escape']" size="is-xl" type="is-white" class="html-tooltip">
        <b-icon
                icon="information-outline"
                size="is-small">
        </b-icon>
      <template v-slot:content>
        <div v-html="content"></div>
      </template>
    </b-tooltip>
</template>

<script>
    export default {
        label: 'tooltip',
        data () {
            return {}
        },
        props: {
            content: { type: String },
            position: { type: String }
        },
    }
</script>

<style>
.html-tooltip strong {
  font-weight: bold;
}
 .b-tooltip.html-tooltip .tooltip-content {
  text-align: left;
  white-space: normal;
}
 .html-tooltip {
   line-height: 1.50;
 }
.html-tooltip p {
  text-align: left;
  white-space: normal;
  padding: 0.2em;
  margin-bottom: 0 !important;
}
.html-tooltip ul {
  padding-left: 1.5em;
  list-style-type: disc;

}
</style>
